export const formatEventTime = (start: Date, end: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  };
  // Same day event
  if (start.toDateString() === end.toDateString()) {
    const startTime = start.toLocaleTimeString("it-IT", {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
    const endTime = end.toLocaleTimeString("it-IT", {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
    const date = start.toLocaleDateString("it-IT", {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
    return `${date}, ${startTime} - ${endTime}`;
  }
  // Multi-day event
  const startFormatted = start.toLocaleDateString("it-IT", options);
  const endFormatted = end.toLocaleDateString("it-IT", options);
  return `${startFormatted} - ${endFormatted}`;
};
